import { collabStateManager } from '@databases/collab-state-manager';

import { type LiveDatabaseSizeMetrics } from './types';

export function getLiveDatabaseSizeMetrics(
  contentId: string
): LiveDatabaseSizeMetrics | undefined {
  const manager = collabStateManager.getCollabManager(contentId);

  if (!manager) {
    return;
  }

  try {
    const db = manager.database;

    return {
      contentId,
      entriesCount: db.entries.length,
      fieldsCount: db.fields.length,
      viewsCount: db.views.length
    };
  } catch {
    return;
  }
}
